import { render, staticRenderFns } from "./generic_personal_information.vue?vue&type=template&id=457fa16d&"
import script from "./generic_personal_information.vue?vue&type=script&lang=js&"
export * from "./generic_personal_information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports